<!--
  Usage: 
  <GlowIcon icon="fa-thin fa-face-smile" size="md" />
-->
<script setup lang="ts">
import { cn } from "@/lib/utils"

export interface Props {
  icon: string
  size?: "md" | "lg"
}

withDefaults(defineProps<Props>(), {
  size: "md",
})

const sizeItem = {
  md: "h-20 w-20",
  lg: "h-32 w-32",
}

const paddingItem = {
  md: "p-3",
  lg: "p-5",
}

const sizeIcon = {
  md: "h-7 w-7",
  lg: "h-9 w-9",
}

const sizeCSS = {
  md: "80px",
  lg: "128px",
}
</script>
<template>
  <div
    :class="
      cn(
        'glowcircle flex flex-col items-center justify-center',
        paddingItem[size],
        sizeItem[size]
      )
    "
  >
    <div
      class="z-1 flex h-full w-full items-center justify-center rounded-full bg-white"
    >
      <FaIcon :icon :class="cn('text-afbranding-theme', sizeIcon[size])" />
    </div>
  </div>
</template>

<style scoped>
.glowcircle {
  position: relative;

  &:before {
    content: "";
    position: absolute;
    margin: auto;
    width: calc(v-bind(sizeCSS[size]) * 0.8);
    height: calc(v-bind(sizeCSS[size]) * 0.8);
    border-radius: 100%;
    background: linear-gradient(
      90deg,
      rgba(var(--af-gradient-start-rgb), 0.4) 0%,
      rgba(var(--af-gradient-end-rgb), 0.4) 100%
    );
  }
  &:after {
    content: "";
    position: absolute;
    width: v-bind(sizeCSS[size]);
    height: v-bind(sizeCSS[size]);
    border-radius: 100%;
    background: linear-gradient(
      90deg,
      rgba(var(--af-gradient-start-rgb), 0.1) 0%,
      rgba(var(--af-gradient-end-rgb), 0.1) 100%
    );
  }
}
</style>
